
(function () {
  function formatDate(date) {
    return date.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short'
    });
  }

  function buildBenefits() {
    var wrapper = document.createElement('div');
    wrapper.className = 'bnf-product-benefits';

    wrapper.innerHTML = `
      <div class="bnf-benefits-grid">
        <div class="bnf-benefit-item">
          <div class="bnf-benefit-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M3 7h11v11H3zM14 11h4l3 4v3h-7zM7 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM18 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>
            </svg>
          </div>
          <div class="bnf-benefit-text">Free shipping on prepaid orders above Rs. 1,200/-</div>
        </div>

        <div class="bnf-benefit-item">
          <div class="bnf-benefit-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="9"/>
              <path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18"/>
            </svg>
          </div>
          <div class="bnf-benefit-text">Worldwide Shipping</div>
        </div>

        <div class="bnf-benefit-item">
          <div class="bnf-benefit-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <rect x="2.5" y="5" width="19" height="14" rx="2"/>
              <path d="M3 10h18M7 15h4"/>
            </svg>
          </div>
          <div class="bnf-benefit-text">COD Available</div>
        </div>
      </div>

      <div class="bnf-delivery-timeline">
        <div class="bnf-timeline-item">
          <div class="bnf-timeline-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M7 2v3M17 2v3M3.5 9.5h17M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"/>
            </svg>
          </div>
          <div class="bnf-timeline-date" data-date="ordered"></div>
          <div class="bnf-timeline-label">Ordered</div>
        </div>

        <div class="bnf-timeline-line" aria-hidden="true"></div>

        <div class="bnf-timeline-item">
          <div class="bnf-timeline-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="m5 12 4 4L19 6"/>
              <path d="M21 12a9 9 0 1 1-2.64-6.36"/>
            </svg>
          </div>
          <div class="bnf-timeline-date" data-date="ready"></div>
          <div class="bnf-timeline-label">Order Ready</div>
        </div>

        <div class="bnf-timeline-line" aria-hidden="true"></div>

        <div class="bnf-timeline-item">
          <div class="bnf-timeline-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M3 7h11v10H3zM14 10h4l3 3v4h-7z"/>
              <circle cx="7" cy="19" r="2"/>
              <circle cx="18" cy="19" r="2"/>
            </svg>
          </div>
          <div class="bnf-timeline-date" data-date="delivery"></div>
          <div class="bnf-timeline-label">Delivered</div>
        </div>
      </div>
    `;

    var today = new Date();
    var readyStart = new Date(today);
    var readyEnd = new Date(today);
    var deliveryStart = new Date(today);
    var deliveryEnd = new Date(today);

    readyStart.setDate(today.getDate() + 1);
    readyEnd.setDate(today.getDate() + 2);
    deliveryStart.setDate(today.getDate() + 5);
    deliveryEnd.setDate(today.getDate() + 7);

    wrapper.querySelector('[data-date="ordered"]').textContent =
      formatDate(today);

    wrapper.querySelector('[data-date="ready"]').textContent =
      formatDate(readyStart) + ' - ' + formatDate(readyEnd);

    wrapper.querySelector('[data-date="delivery"]').textContent =
      formatDate(deliveryStart) + ' - ' + formatDate(deliveryEnd);

    return wrapper;
  }

  function initBenefits() {
    if (document.querySelector('.bnf-product-benefits')) return;

    var customInfo = document.querySelector('.custom-information');

    if (!customInfo) {
      console.warn('BNF benefits: .custom-information was not found on this page.');
      return;
    }

    customInfo.parentNode.insertBefore(buildBenefits(), customInfo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefits);
  } else {
    initBenefits();
  }

  document.addEventListener('shopify:section:load', initBenefits);
})();
